export const pt = {
    title: `Painel`,
    welcome: `Bem-vindo de volta, {name}!`,
};
//# sourceMappingURL=pt.js.map